import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { _HttpClient } from '@delon/theme';
import { NzModalRef } from 'ng-zorro-antd';
import { apiPrefix } from '../../utils/constants';

@Component({
  selector: 'app-icc-patch-dialog',
  templateUrl: './icc-patch-dialog.component.html',
  styles: ['.patch-dialog-form{transform: translateX(-30px)}'],
})
export class IccPatchDialogComponent implements OnInit {
  constructor(private dialogService: DialogService, public http: _HttpClient, private modal: NzModalRef) {}

  // 已存在贴片
  existPatch = '';

  subject = '选择贴片';
  mediaUrl = apiPrefix + '/common/attachment/download' + '?';
  groupUrl = null;
  itemUrl = null;
  content = null;

  patchGroups = [];

  patchTypes = [];

  canSelectPatchTypes = [];

  patchItems = [];

  patchGroupDto = {
    id: '',
    type: -1,
  };

  msgType;
  contentType;

  patchStrategy = {
    groupId: null, // 贴片组id
    groupName: null,
    varName: null, // 消息中的变量占位符
    method: null, // 方式
    type: null, // 内容类型
    itemId: null, // 贴片id
    itemName: null,
    weightParam: {
      // key:贴片id value:权重
    },
  };

  ngOnInit() {
    this.patchStrategy.method = '1';
    if (this.msgType !== null && this.contentType !== null) {
      this.getPatchGroupsByMsgType(this.msgType, this.contentType);
    }
  }

  searchPatchGroup(event) {}

  changePatchGroupMethod(event) {
    this.patchItems.forEach(e => {
      e.state = 0;
      e.weight = null;
    });
  }

  selectPatchType(event) {}

  destroy() {
    this.modal.close();
  }

  confirm() {
    this.patchStrategy.varName = '_patch_' + this.patchStrategy.groupId;
    const group = this.patchGroups.find(g => g.id === this.patchStrategy.groupId);
    this.patchStrategy.groupName = group ? '_patch_' + group.name : this.patchStrategy.varName;
    try {
      this.checkPatchData();
    } catch (e) {
      this.dialogService.notification.error(this.subject, e.message);
      return;
    }
    this.modal.close(this.patchStrategy);
  }

  checkPatchData() {
    if (!this.patchStrategy.method) {
      throw new Error('请选择贴片应用类型');
    }
    if (this.patchStrategy.method === '1') {
      const obj = this.patchItems.find(item => item.state === 1);
      if (obj) {
        this.patchStrategy.itemId = obj.id;
        this.patchStrategy.itemName = obj.title;
      } else {
        throw new Error('请至少选择一个贴片');
      }
    }
    if (this.patchStrategy.method === '3') {
      let isEmpty = true;
      let count = 0;
      this.patchItems
        .filter(i => i.state === 1)
        .forEach(item => {
          if (!item.weight || item.weight <= 0) {
            throw new Error('选中的贴片必须设置比例');
          }
          count = count + item.weight;
          this.patchStrategy.weightParam[item.id] = item.weight;
          isEmpty = false;
        });
      if (isEmpty) {
        throw new Error('请至少选择一个贴片');
      } else if (count !== 100) {
        throw new Error('按比例贴片，所有贴片比例和必须是100%');
      }
    }
  }

  /**
   * 根据消息类型类型获取贴片
   * @param msgType
   */
  getPatchGroupsByMsgType(msgType: number, contentType: number) {
    const getPatchGroupUrl = this.groupUrl + '/' + msgType + '/' + contentType;
    this.http.get(getPatchGroupUrl).subscribe(
      res => {
        if (res.status === 0) {
          // this.patchGroups = res.data.patchGroupDtos;
          for (let i = 0; i < res.data.patchGroupDtos.length; i++) {
            let patchGroup = res.data.patchGroupDtos[i];
            if (this.content) {
              if (this.content.indexOf('${_patch_' + patchGroup.name + '}') === -1) {
                this.patchGroups.push(patchGroup);
              }
            } else {
              this.patchGroups.push(patchGroup);
            }
          }
          this.patchGroups = this.patchGroups.filter(item => {
            if (this.existPatch.indexOf('${_patch_' + item.name + '}') !== -1) {
              return false;
            } else {
              return true;
            }
          });
          // this.patchTypes = res.data.patchTypeDtos;
          if (res.data.patchTypeDtos && res.data.patchTypeDtos.length > 0) {
            for (let i = 0; i < res.data.patchTypeDtos.length; i++) {
              this.canSelectPatchTypes.push(res.data.patchTypeDtos[i].id);
            }
          }
        } else {
          this.dialogService.notification.error(this.subject, res.errorMsg);
        }
        if (this.patchGroups && this.patchGroups.length) {
          this.patchStrategy.groupId = this.patchGroups[0].id;
          this.getPatchTypes();
        }
      },
      () => {
        this.dialogService.notification.error(this.subject, '失败，系统错误！');
      },
    );
  }

  /**
   * 获取贴片组的贴片类型
   */
  getPatchTypes() {
    if (!this.patchStrategy.groupId) {
      return;
    }
    this.patchTypes = [];
    this.patchStrategy.type = null;
    this.patchItems = [];
    for (let i = 0; i < this.patchGroups.length; i++) {
      let group = this.patchGroups[i];
      if (this.patchStrategy.groupId == group.id) {
        if (group.text && this.canSelectPatchTypes.indexOf(1) !== -1) {
          this.patchTypes.push({ id: 1, name: '文本' });
        }
        if (group.voice && this.canSelectPatchTypes.indexOf(2) !== -1) {
          this.patchTypes.push({ id: 2, name: '语音' });
        }
        if (group.image && this.canSelectPatchTypes.indexOf(3) !== -1) {
          this.patchTypes.push({ id: 3, name: '图片' });
        }
      }
    }
    if (this.patchTypes && this.patchTypes.length) {
      this.patchStrategy.type = this.patchTypes[0].id;
      this.getPatchItemByGroupIdAndType();
    }
  }

  selectPatchTypeClick() {
    if (!this.patchStrategy.groupId) {
      this.dialogService.notification.error(this.subject, '请先选择贴片名称');
      return;
    }
  }

  /**
   * 选择贴片项
   */
  getPatchItemByGroupIdAndType($event?) {
    const getPatchGroupUrl = this.itemUrl;
    if (!this.patchStrategy.groupId) {
      return;
    }
    if (!this.patchStrategy.type) {
      return;
    }
    this.patchGroupDto.id = this.patchStrategy.groupId;
    this.patchGroupDto.type = this.patchStrategy.type;
    this.http.post(getPatchGroupUrl, this.patchGroupDto).subscribe(res => {
      if (res.status === 0) {
        this.patchItems = [];
        const items = res.data;
        if (items && items.length > 0) {
          items.forEach(item => {
            this.patchItems.push(item);
            item.state = 0;
            item.weight = null;
            if (item.type === 3) {
              item.imgTempList = [{ url: this.mediaUrl + item.content }];
            }
          });
        }
      } else {
        this.dialogService.notification.error(this.subject, '获取贴片失败');
      }
    });
  }

  selectPatchItemChange(value: any, obj: any) {
    if (this.patchStrategy.method === '1') {
      // 指定贴片
      obj.state = value ? 1 : 0;
      this.patchItems
        .filter(item => item.id !== obj.id)
        .forEach(item => {
          item.state = 0;
        });
    }
    if (this.patchStrategy.method === '3') {
      obj.state = value ? 1 : 0;
    }
  }
}
